<script lang="ts">
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Types
	import type { InputClickEvent } from '../../../../types/InputClickEvent';
	//Design system components
	import { Toggle, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;
	let checked = $settingsStore.led_status_disable;
	let localIp = get_local_ip(id);
	let loading = false;

	const sentRequest = async (e: InputClickEvent) => {
		loading = true;
		let res;
		checked = e.target.checked;
		if (localIp) {
			res = await localReq(device, `${localIp}/settings/`, 'post', {
				led_status_disable: checked,
			});
		} else {
			res = await postReq(`/device/settings/led_status_disable`, {
				id: id,
				enabled: checked ? 1 : 0,
			});
		}

		if (res.isok) {
			settings.led_status_disable = checked;
			devices_settings.update_devices_settings(id, settings);
			toast.open({
				type: 'success',
				title: !checked
					? $format('led_light_enabled_scc_toast')
					: $format('led_light_disabled_scc_toast') ||
						`Led status light was ${!checked ? 'enabled' : 'disabled'}.`,
			});
		} else {
			checked = !checked;
			toast.open({ type: 'danger', title: $format('error_global') });
		}
		loading = false;
	};
</script>

<Toggle size="m" disabled={loading} {checked} on:click={sentRequest} id="toggle-u3jbxti">
	{$format('device_wi_fi_led_description', {
		default: 'Disable wifi status led.',
	})}
</Toggle>
